import { COMMERCE_HUB_ENTERPRISE, COMMERCE_HUB_PROFESSIONAL, MARKETING_HUB_ENTERPRISE, MARKETING_HUB_PROFESSIONAL, MARKETING_HUB_STARTER, SALES_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SALES_HUB_STARTER, SERVICE_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL, SERVICE_HUB_STARTER } from 'self-service-api/constants/ApiNames';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
const QuantityPackApiNameToUpgradeProduct = {
  [MARKETING_HUB_STARTER]: {
    'additional-marketing-contacts': UpgradeProducts.MARKETING_STARTER_CONTACTS,
    'additional-legacy-contacts': UpgradeProducts.MARKETING_STARTER_CONTACTS
  },
  [MARKETING_HUB_PROFESSIONAL]: {
    'additional-marketing-contacts': UpgradeProducts.MARKETING_PROFESSIONAL_CONTACTS,
    'additional-legacy-contacts': UpgradeProducts.MARKETING_PROFESSIONAL_CONTACTS
  },
  [MARKETING_HUB_ENTERPRISE]: {
    'additional-marketing-contacts': UpgradeProducts.MARKETING_ENTERPRISE_CONTACTS,
    'additional-legacy-contacts': UpgradeProducts.MARKETING_ENTERPRISE_CONTACTS
  },
  [SALES_HUB_STARTER]: {
    'additional-sales-seats': UpgradeProducts.SALES_STARTER_USER
  },
  [SALES_HUB_PROFESSIONAL]: {
    'additional-sales-seats': UpgradeProducts.SALES_PROFESSIONAL_USER
  },
  [SALES_HUB_ENTERPRISE]: {
    'additional-sales-seats': UpgradeProducts.SALES_ENTERPRISE_USER
  },
  [SERVICE_HUB_STARTER]: {
    'additional-service-seats': UpgradeProducts.SERVICE_STARTER_USER
  },
  [SERVICE_HUB_PROFESSIONAL]: {
    'additional-service-seats': UpgradeProducts.SERVICE_PROFESSIONAL_USER
  },
  [SERVICE_HUB_ENTERPRISE]: {
    'additional-service-seats': UpgradeProducts.SERVICE_ENTERPRISE_USER
  },
  [COMMERCE_HUB_PROFESSIONAL]: {
    'additional-commerce-seats': UpgradeProducts.COMMERCE_HUB_PROFESSIONAL
  },
  [COMMERCE_HUB_ENTERPRISE]: {
    'additional-commerce-seats': UpgradeProducts.COMMERCE_HUB_ENTERPRISE
  }
};
export default QuantityPackApiNameToUpgradeProduct;